export * from './lib/top-border-card/top-border-card.component';
